export default "__VITE_ASSET__GxQilxWx__"